import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getContentSummary } from "../../../services/api/contentAdminService";
import { isAuthError, isCanceledError } from "../../../services/errors/errorHandler";
import AdminHeader from "../AdminHeader";
import { COLLECTIONS, MEDIA_LIBRARY_PATH, collectionPath } from "./collections";
import "../admin.css";
import "./content.css";

/** "3 on the site, 1 hidden" from a summary row (A.12 GET /api/admin/content). */
export const describeCounts = (row) => {
  if (!row) return "";
  const hidden = Math.max(0, row.items - row.visible);
  if (row.items === 0) return "Nothing yet";
  return hidden ? `${row.visible} on the site, ${hidden} hidden` : `${row.visible} on the site`;
};

/**
 * Site content start screen: the areas she can change, in plain words, with
 * how many items each has, plus "Photos and files".
 */
export default function ContentHome() {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    getContentSummary({ signal: controller.signal })
      .then((data) => {
        if (controller.signal.aborted) return;
        setSummary(Object.fromEntries((data.collections || []).map((row) => [row.collection, row])));
      })
      .catch((err) => {
        if (controller.signal.aborted || isCanceledError(err) || isAuthError(err)) return;
        // The counts are a hint; every area still opens.
        setError(err.message || "Could not load the counts.");
      });
    return () => controller.abort();
  }, []);

  return (
    <div className="admin">
      <AdminHeader />
      <main id="main" className="admin-main cms" tabIndex={-1}>
        <h1>Site content</h1>
        <p className="admin-muted">Choose what you’d like to change. Changes show on the site within a minute.</p>
        {error && <p className="admin-warning" role="status">{error}</p>}

        <ul className="cms-areas">
          {COLLECTIONS.map((c) => (
            <li key={c.id}>
              <Link className="cms-area" to={collectionPath(c.id)} data-collection={c.id}>
                <span className="cms-area__name">{c.label}</span>
                <span className="cms-area__blurb">{c.blurb}</span>
                {summary && !c.fixed && <span className="cms-area__count">{describeCounts(summary[c.id])}</span>}
              </Link>
            </li>
          ))}
          <li>
            <Link className="cms-area" to={MEDIA_LIBRARY_PATH}>
              <span className="cms-area__name">Photos and files</span>
              <span className="cms-area__blurb">Every picture and PDF you’ve uploaded: descriptions, space used, delete.</span>
            </Link>
          </li>
        </ul>
      </main>
    </div>
  );
}
